module.exports = __webpack_public_path__ + "static/media/NBIA.6bb23eab.png";